import React from 'react';
import { useTranslation } from '../i18n/TranslationContext';

interface ContractDataIntroOverlayProps {
  isVisible: boolean;
  onClose: () => void;
  isFirstTime: boolean;
}

export const ContractDataIntroOverlay: React.FC<ContractDataIntroOverlayProps> = ({ 
  isVisible, 
  onClose, 
  isFirstTime 
}) => {
  const { t } = useTranslation();
  
  if (!isVisible) return null;

  return (
    <div className="profile-intro-overlay">
      {/* Dim background */}
      <div className="overlay-backdrop" onClick={onClose}></div>
      
      {/* Overlay content */}
      <div className="overlay-content">
        <div className="overlay-header">
          <div className="overlay-icon">
            <span className="text-2xl">📋</span>
          </div>
          <h2 className="overlay-title">{t('contractDataIntro.title')}</h2>
        </div>
        
        <div className="overlay-body">
          <p className="overlay-description">
            {t('contractDataIntro.subtitle')}
          </p>
          
          <div className="overlay-list">
            <h3>{t('contractDataIntro.usedFor')}</h3>
            <ul>
              <li>
                <strong>{t('contractDataIntro.legalEmployment')}:</strong> {t('contractDataIntro.legalEmploymentDesc')}
              </li>
              <li>
                <strong>{t('contractDataIntro.taxDocumentation')}:</strong> {t('contractDataIntro.taxDocumentationDesc')}
              </li>
              <li>
                <strong>{t('contractDataIntro.insuranceCoverage')}:</strong> {t('contractDataIntro.insuranceCoverageDesc')}
              </li>
            </ul>
          </div>
          
          <div className="overlay-privacy">
            <p>{t('contractDataIntro.privacyNote')}</p>
            <p><strong>{t('contractDataIntro.consentNote')}</strong></p>
          </div>
        </div>
        
        <div className="overlay-footer">
          <button 
            className="overlay-action-button"
            onClick={onClose}
          >
            {t('contractDataIntro.okayGotIt')}
          </button>
        </div>
      </div>
    </div>
  );
};